module.exports = __webpack_public_path__ + "static/media/homepack-4g_box.9bcc601f.png";